export const cls = (...parts: Array<string | false | undefined | null>) => parts.filter(Boolean).join(' ')
export const pct = (n: number, d: number) => d === 0 ? 0 : Math.round((n / d) * 100)
